export const CFAR_CONTRACT_TYPE = {
  LEGACY: "Legacy",
  HTS: "Hts",
} as const;

export type CfarContractType =
  (typeof CFAR_CONTRACT_TYPE)[keyof typeof CFAR_CONTRACT_TYPE];

export interface ContractType {
  ContractType: CfarContractType;
}
